import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { FormatSelector } from "./FormatSelector";
import type { VideoFormat } from "@/lib/hooks/useImageUpload";

interface GeneralInfoStepProps {
  name: string;
  setName: (name: string) => void;
  formats: VideoFormat[];
  handleFormatChange: (values: string[]) => void;
  isSubmitting: boolean;
  nextStep: () => void;
  canGoToStep2: boolean;
}

export const GeneralInfoStep = ({
  name,
  setName,
  formats,
  handleFormatChange,
  isSubmitting,
  nextStep,
  canGoToStep2,
}: GeneralInfoStepProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-12 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="space-y-4 2k:space-y-8 4k:space-y-12">
        <Label
          htmlFor="video-name"
          className="font-h3 text-xl 2k:text-4xl 4k:text-6xl"
        >
          {t("createVideo.videoName")}
        </Label>
        <Input
          id="video-name"
          placeholder={t("createVideo.videoNamePlaceholder")}
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="max-w-xl h-14 2k:max-w-3xl 2k:h-24 4k:max-w-5xl 4k:h-36 rounded-2xl border-black/5 bg-white px-6 2k:px-12 text-lg 2k:text-3xl 4k:text-5xl shadow-sm focus:border-black/20"
          disabled={isSubmitting}
        />
      </div>

      <div className="space-y-4">
        <FormatSelector
          value={formats}
          onValueChange={handleFormatChange}
          disabled={isSubmitting}
        />
      </div>

      <div className="hidden lg:flex justify-end pt-8">
        <Button
          type="button"
          onClick={nextStep}
          disabled={!canGoToStep2}
          className="rounded-full bg-black hover:bg-black/90 text-white px-12 py-7 2k:px-20 2k:py-12 4k:px-30 4k:py-18 text-lg 2k:text-3xl 4k:text-5xl cursor-pointer disabled:opacity-30"
        >
          {t("common.next") || "Next"}
        </Button>
      </div>
    </div>
  );
};
